export default "__VITE_ASSET__BW2aPPom__"